export default class Faq {
    constructor(element) {
        this.element = element;
        this.items = this.element.querySelectorAll(".faq-item")

        for (const item of this.items) {
            item.addEventListener("click", () => this.toggleItem(item))
        }
    }

    toggleItem(element) {
        element.classList.toggle("collapsed")
    }
}
